import KeyboardKeyIcon from '@/components/ui/keyboard-key-icon';
import { useDealContext } from '@/contexts/deal-provider';
import useFavoriteMutation from '@/hooks/use-favorite-mutation';
import { HOTKEYS } from '@/lib/hotkeys';
import { cn } from '@/lib/utils';

import { useDealByShortId } from '@/hooks/use-deals-selectors';
import { favoriteStore } from '@/models/stores';
import { Star } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useHotkeys } from 'react-hotkeys-hook';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';

const DealFavoriteUnfavorite = observer(() => {
  const { currentShortId } = useDealContext();
  const deal = useDealByShortId(currentShortId);
  const favorited = deal ? favoriteStore.isFavoritedByUser(deal.id) : false;

  if (!deal) {
    return null;
  }

  const { toggleFavorite } = useFavoriteMutation(deal);

  useHotkeys(HOTKEYS.DEAL_FAVORITE_UNFAVORITE, toggleFavorite);

  return (
    <div onClick={toggleFavorite}>
      <Tooltip>
        <TooltipTrigger>
          <Star
            className={cn('h-3.5 w-3.5 cursor-pointer', {
              'fill-yellow-500': favorited,
            })}
          />
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          align="center"
          className="flex flex-row gap-1 items-center"
        >
          {favorited ? <div>Unfavorite deal</div> : <div>Favorite deal</div>}
          <KeyboardKeyIcon>{HOTKEYS.DEAL_FAVORITE_UNFAVORITE}</KeyboardKeyIcon>
        </TooltipContent>
      </Tooltip>
    </div>
  );
});

export default DealFavoriteUnfavorite;
